<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    :title="dialogTitle"
    dialog-width="32%"
    :agree-text="featureId === 'new' ? 'dialog.agreeAdd' : 'dialog.agreeSave'"
    no-paddings-x
    no-paddings-y
    header-shadow
    min-body-height="60vh"
    :loading="isStickyButtonsLoading"
    @agree="onAgree"
    :has-agree="featureId === 'new' || editing"
  >
    <template #body>
      <v-col cols="12" v-if="featureId !== null">
        <feature-card-basic
          ref="feature-card"
          :layer="layer"
          persist-old-extras
          :custom-feature-id="featureId"
          :custom-layer-id="layer.id"
          disable-title-floating
          is-dialog-feature-card
          :icons-to-show="['showHistory', 'showNotes', 'showAttachments']"
          :object-extras-tabs="['changeHistory', 'notes', 'attachments']"
          @featureAdded="onFeatureModify"
          @featureEdited="onFeatureModify"
          @featureDeleted="onFeatureModify"
          @featureEditing="onFeatureEditing"
          :form-constant-values="formConstantValues"
        />
      </v-col>
    </template>
  </main-large-dialog>
</template>
<script>
import { get } from 'vuex-pathify';

import FeatureCardBasic from '@/components/FeatureCardBasic';
import MainLargeDialog from '@/components/MainLargeDialog';

export default {
  name: 'FeatureCardInspectionDialog',
  components: { FeatureCardBasic, MainLargeDialog },
  props: {
    layer: {
      required: true,
    },
    featureId: {
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
    formConstantValues: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    isStickyButtonsLoading: get('sidebar/isStickyButtonsLoading'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        if (!nV) {
          this.$refs['feature-card']?.stopEditing();
          this.editing = false;
        }
        this.$emit('update:isVisible', nV);
      },
    },
    dialogTitle() {
      return this.featureId !== 'new'
        ? this.$i18n.t('sidebar.inspections.feature')
        : this.$i18n.t('sidebar.inspections.addFeature');
    },
  },
  data: () => ({
    editing: false,
  }),
  methods: {
    onAgree() {
      if (this.featureId === 'new') {
        this.$refs['feature-card']?.handleFeatureAdding();
      } else {
        this.$refs['feature-card']?.handleFeatureEditing();
      }
    },
    onFeatureModify(v) {
      this.computedIsVisible = false;
      this.$emit('inspectionAdded', v);
    },
    onFeatureEditing() {
      this.editing = true;
    },
  },
};
</script>
